export default "__VITE_ASSET__A9Ys9TTp__"